module.exports = __webpack_public_path__ + "c41cd7db51e063bffab07c756f95fe78.pdf";